"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcaneShotAbilityHandler = exports.ArcaneShotActorAbilityFactory = exports.ArcaneShotAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const MaxAttributeDecrease_1 = require("../../core/effects/core/MaxAttributeDecrease");
const EffectType_1 = require("../../core/effects/EffectType");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ArcaneShotAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ArcaneShot;
        this.__typeName = "ArcaneShot";
    }
}
exports.ArcaneShotAbilityArgs = ArcaneShotAbilityArgs;
let ArcaneShotActorAbilityFactory = class ArcaneShotActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ArcaneShot", "OneEnemies", 1);
    }
};
ArcaneShotActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ArcaneShot")
], ArcaneShotActorAbilityFactory);
exports.ArcaneShotActorAbilityFactory = ArcaneShotActorAbilityFactory;
let ArcaneShotAbilityHandler = class ArcaneShotAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        let projectiles = 2;
        if (container.hasEffectOfType(ability.invokerId, EffectType_1.EffectType.HuntersSupremacy)) {
            projectiles = 4;
        }
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "ranged",
            projectiles: Array(projectiles).fill(0).map(() => ({
                type: "ArcaneArrow",
                path: "line",
                targetId: selectedEnemy,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Chaos", 35)
                ],
            })),
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(AttributeType_1.AttributeType.ChaosDamageImmunity, 25),
                    onAppliedOrResisted: (sequence, _, applied) => sequence.push(new core_1.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "chest")
                        : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "PurpleExplosion"))
                });
            }
        });
    }
};
ArcaneShotAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ArcaneShot)
], ArcaneShotAbilityHandler);
exports.ArcaneShotAbilityHandler = ArcaneShotAbilityHandler;
